import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { AuthGuardService } from './services/security/auth-guard.service';

export const routes: Routes = [
    { path: '', redirectTo:'modulacion', pathMatch: 'full'},
    { path: 'auth', loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule) },
    { path: 'modulacion', canActivate: [AuthGuardService], loadChildren: () => import('./pages/modulacion/modulacion.module').then(m => m.ModulacionModule) },
    { path: 'impresion', canActivate: [AuthGuardService], loadChildren: () => import('./pages/modulacion/modulacion.module').then(m => m.ModulacionModule) },
    { path: 'mantenimiento-impresora', canActivate: [AuthGuardService], loadChildren: () => import('./pages/modulacion/modulacion.module').then(m => m.ModulacionModule) },
    { path: 'mantenimiento-codigo', canActivate: [AuthGuardService], loadChildren: () => import('./pages/modulacion/modulacion.module').then(m => m.ModulacionModule) }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: false });